module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-container"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info-container"
    }
  }, [_c('h4', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToElement('planos')
      }
    }
  }, [_vm._v("PLANOS")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToElement('beneficios')
      }
    }
  }, [_vm._v("\n      BENEFÍCIOS\n    ")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToElement('footer')
      }
    }
  }, [_vm._v("\n      CONTATO\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo-container-desk"
    }
  }, [_c('img', {
    attrs: {
      "id": "logo-mm",
      "src": require("./Logo_Move_Mais.svg")
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "line"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "logo-pamcard",
      "src": require("./Logo_Pamcard_Branco_seta_amarela.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo-container-mob"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./mmMob.svg")
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "line"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./pamcardMob.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-44e16068!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/hotsite/components/header/header-hot-site.vue
// module id = 2114
// module chunks = 1